import TrackWrapper from '@/common/TrackWrapper';
import CVTLogo from '@/home/assets/CVTLogo';
import formatEvent from '@/home/utils/formatEvent';
import Sections from '~/constants/home/sections';
import ArrowRight from '~/icons/ArrowRight';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';
import {
  CVTBannerContainer,
  ContentBlue,
  ContentWhite,
  DesktopCTA,
  DesktopText,
  Divider,
  MobileText
} from './CVTBanner.styles';

function CVTBanner() {
  const customAttributes = {
    description: 'CVT banner cta'
  };

  const viewEvent = formatEvent('Viewed - Home feed section', customAttributes);

  return (
    <TrackWrapper event={viewEvent}>
      <a
        href="/value-tracker"
        data-qa="CVT Banner"
        data-analytics-id="Home feed card"
        data-analytics-attributes={JSON.stringify({
          description: 'CVT banner cta'
        })}
      >
        <CVTBannerContainer>
          <ContentBlue>
            <div className="flex items-center gap-8 l:gap-24">
              <div className="flex items-center">
                <CVTLogo className="h-[18px] min-w-[85px] s:mr-16 l:h-full l:w-[144px]" />
              </div>
              <Divider />
              <MobileText>Know your vehicle’s value</MobileText>
              <ArrowRight className="l:hidden" />
            </div>
          </ContentBlue>
          <ContentWhite>
            <DesktopText>Always know the value of your vehicle</DesktopText>
            <DesktopCTA data-qa="cvt-learn-more">Learn More</DesktopCTA>
          </ContentWhite>
        </CVTBannerContainer>
      </a>
    </TrackWrapper>
  );
}

export default withErrorBoundary(
  CVTBanner,
  undefined,
  undefined,
  Sections.CVTBanner
);
